export const chartPieHighlightFunctions = {
  onHoverIn: (chartApi: Highcharts.Chart | null, key: string) => {
    if (!chartApi) return;

    try {
      chartApi.series?.at(0)?.data.forEach((point) => {
        if (point.name === key) {
          point.setState("hover");
        } else {
          point.setState("");
        }
      });
    } catch (e) {
      console.error(`chartPieHighlightFunctions.onHoverIn error: ${e}`);
    }
  },

  onHoverOut: (chartApi: Highcharts.Chart | null) => {
    if (!chartApi) return;

    try {
      chartApi.series[0]?.data.forEach((point) => {
        point.setState("");
        const el = point.graphic?.element as SVGElement | undefined;
        if (el) {
          el.style.opacity = "1";
        }
      });
    } catch (e) {
      console.error(`chartPieHighlightFunctions.onHoverOut error: ${e}`);
    }
  },
};
